module.exports = __webpack_public_path__ + "img/recommed-img2.9ebc0f3d.jpg";